import { Box, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { IconButton } from "../../../../shared";
import { isDefaultPlatformRole } from "../../../../interfaces";

/**
 * Info cell renderer - navigates to edit/view role page
 */
export function Info(props: any) {
    const navigate = useNavigate();
    const { value, data } = props;
    const isDefault = data ? isDefaultPlatformRole(data) : false;

    const handleClick = () => {
        navigate(`/admin/roles/edit/${value}`);
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title={isDefault ? "View details" : "View role"} placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                        borderRadius: "4px",
                    }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export function ScopeCellRenderer(props: any) {
    const isDefault = props.data ? isDefaultPlatformRole(props.data) : false;

    return (
        <Box display="flex" alignItems="center" height="100%">
            <Chip
                size="sm"
                variant="soft"
                color={isDefault ? "neutral" : "primary"}
                sx={{ borderRadius: "4px", border: "1px solid", borderColor: "divider" }}
            >
                {isDefault ? "Platform" : "Organization"}
            </Chip>
        </Box>
    );
}
